import PropTypes from 'prop-types';
import { useState } from 'react';

import { FormModal, Snackbar } from '../../default';
import { CreateApplicationServiceForm } from '../../forms';

/**
 * @description Renders a modal component for creating a new application service.
 *
 * @author Maria Eduarda Franke
 * @param {boolean} open - Determines whether the modal is open or not.
 * @param {function} onClose - Callback function to close the modal.
 * @returns {JSX.Element} The rendered CreateApplicationServiceModal component.
 */
const CreateApplicationServiceModal = ({ open, onClose }) => {

    const [showSnackbar, setShowSnackbar] = useState(false)

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') return
        setShowSnackbar(false)
    }

    return (
        <>
            <FormModal
                title='Criar aplicação'
                open={open}
                onClose={onClose}
            >
                <CreateApplicationServiceForm onClose={onClose} setShowSnackbar={setShowSnackbar} />
            </FormModal>
            <Snackbar
                open={showSnackbar}
                onClose={handleSnackbarClose}
                vertical='bottom'
                horizontal='right'
                severity='success'
                variant='filled'
                message='Nova aplicação criada com sucesso!'
                sx={{ mt: 1 }}
            />
        </>
    )

}

CreateApplicationServiceModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
}

export default CreateApplicationServiceModal